import React from 'react';
import { css } from '@emotion/css';
import { Link, Notification } from 'is24-corecss';
import { IconS24ChevronRight24 } from '@is24/cosma-ui-icons';
import { GRAY300 } from '../../../../../../domain/colors';
import { STORAGEBOX_SERVICE_STATUS } from '../../../../../../@types/storagebox';
import CustomerService from './CustomerService';
import { useIntl } from '@/i18n/hooks/useIntl';
import { default as Msg } from '@/i18n/components/FormattedMessage';
import { PlusBadge } from '@/components/common/display/plusBadge/PlusBadge';

const styles = {
  overviewBullets: css`
    list-style-type: initial;
    padding-left: 50px;
  `,
  overviewTab: { maxWidth: 530 },
  howItWorksTab: {
    subText: { maxWidth: 712, margin: '0 auto' },
    image: {
      width: '100%',
      height: 'auto',
      '@media (max-width: 668px)': { borderBottom: `1px solid ${GRAY300}` },
    },
  },
  statusFrame: css`
    border: 1px solid #d6d6d6;
    border-radius: 4px;
    padding: 24px 16px;
  `,
  statusFrameWrapper: css`
    display: flex;
    align-items: baseline;

    i {
      color: var(--color-text-default);
      font-size: 24px;
      transform: translateY(50%);
    }

    span {
      margin-left: 12px;
    }
  `,
};

const OverviewTab = ({
  status,
  isEntitled,
  url,
}: {
  status: STORAGEBOX_SERVICE_STATUS;
  isEntitled: boolean;
  url: string;
}) => {
  const { t } = useIntl();
  if (status === STORAGEBOX_SERVICE_STATUS.ACTIVATED) {
    return (
      <div style={styles.overviewTab}>
        <Notification
          title={t({
            id: 'benefits.storageService.modal.overview.request.title',
            defaultMessage: 'Anfrage gesendet',
          })}
          type='success'
        />
        <div className='margin-bottom-l' />
        <div className={styles.statusFrame}>
          <div className={styles.statusFrameWrapper}>
            <i className={`is24-icon-time`} data-test-ctx='status-icon' />
            <span className='font-s'>
              {t({
                id: 'benefits.storageService.modal.overview.request.description',
                defaultMessage:
                  'Deine Anfrage wurde erfolgreich gesendet.  LAGERBOX wird sich innerhalb der nächsten 48h bei dir telefonisch melden. Solltest du noch weitere Fragen haben, melde dich beim Kundenservice von Lagerbox ',
              })}
            </span>
          </div>
        </div>
        <div className='margin-bottom-l' />
        <CustomerService />
      </div>
    );
  }
  return (
    <div style={styles.overviewTab}>
      <div className='font-heading-xsmall-regular padding-bottom-l'>
        <Msg
          id='benefits.storageService.modal.overview.paragraph1'
          defaultMessage='Zusätzlichen Platz mieten mit einem Lagerraum von LAGERBOX.'
        />
      </div>
      <ul className='list-check list-spacing-s'>
        <li>
          {!isEntitled
            ? t({
                id: 'benefits.storageService.modal.overview.bullet1IsEntitled',
                defaultMessage: 'Schon ab 1m³ / 1 Woche / 9,95 €',
              })
            : t({
                id: 'benefits.storageService.modal.overview.bullet1',
                defaultMessage: 'Schon ab 9,95 € mtl.',
              })}
        </li>
        <li>
          {t({
            id: 'benefits.storageService.modal.overview.bullet2',
            defaultMessage: 'How are interest rates developing?',
          })}
        </li>
        <li>
          {t({
            id: 'benefits.storageService.modal.overview.bullet3',
            defaultMessage: 'What will the repayment plan...',
          })}{' '}
          <PlusBadge variant='living' />
        </li>
      </ul>
      <ul className={`margin-bottom-l ${styles.overviewBullets}`}>
        <li>
          {t({
            id: 'benefits.storageService.modal.overview.subBullet1',
            defaultMessage: '5% Rabatt auf Basic Paket',
          })}
        </li>
        <li>
          {t({
            id: 'benefits.storageService.modal.overview.subBullet2',
            defaultMessage: '15% Rabatt auf Premium Paket',
          })}
        </li>
      </ul>
      {!isEntitled && (
        <Link href={url} variant='default' endElement={<IconS24ChevronRight24 />}>
          {t({
            id: 'benefits.storageService.modal.overview.WohnenPlusLink',
            defaultMessage: 'WohnenPlus entdecken',
          })}
        </Link>
      )}
    </div>
  );
};

export default OverviewTab;
